module.exports = __webpack_public_path__ + "img/8.ba140f6f.png";